export const DEFAULT_THEME = 'sap_horizon';
export const DEFAULT_LANG = 'en-US';
export const PX_URL = 'https'+'://'+'prod.pxconfig.cloud.sap/api';
export const PX_UNIT_ID = '311a8f95-1235-4945-9a33-ecf33536137c';
export const PX_API_OBJECT = 'pxAPIObject';